import './bml-services.scss';
const TEMPLATE = `
<section class="services fade-up">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6 col-lg-6">
                <p class="section-label" data-animate-child>Дослідження</p>
            </div>
            <div class="col-md-6 col-lg-6">
                <h2 data-animate-child data-delay="200">Експертна діагностика</h2>
                <p data-animate-child data-delay="400">
                    Ми пропонуємо повний спектр експертних лабораторних досліджень для точної діагностики, підтримки
                    клінічних рішень і персоналізованого підходу до кожного клінічного випадку.
                </p>
                <p data-animate-child data-delay="500">
                    Лабораторія виконує патогістологічні, імуногістохімічні, інтраопераційні патогістологічні
                    дослідження та супровід Mohs-хірургії, цитогенетичні дослідження, молекулярно-генетичні
                    дослідження в онкогематології, біохімічні дослідження волосся, цитологічні дослідження
                    гінекологічного і не гінекологічного матеріалу, Second opinion (друга думка
                    експерта-патоморфолога), здійснює морфологічний супровід лікування та клініко-морфологічні
                    кореляції.
                </p>
                <a href="/doslidzhennya" data-animate-child data-delay="600">Дізнатись більше</a>
            </div>
        </div>
    </div>
    <div class="carousel-container" data-animate-child data-delay="800">
        <div class="cards-book" id="cards-book-1" data-section="carousel"></div>
    </div>
</section>
`;

class BmlServices extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
    }
}

customElements.define('bml-services', BmlServices);
